import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "../lib/api";

export default function WhatsAppButton({ reference }) {
  const [number, setNumber] = useState(undefined);
  useEffect(() => { api.get("/support").then(({ data }) => setNumber(data.whatsapp)).catch(() => setNumber(null)); }, []);
  const text = `Olá, equipa BÔ Market. Gostaria de obter informações sobre a minha encomenda nº ${reference}. Obrigado.`;
  const cls = "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold";
  if (!number) return (
    <button disabled title="Contacto de apoio ainda não configurado" className={`${cls} cursor-not-allowed bg-gray-100 text-gray-400`} data-testid="whatsapp-support-btn">
      <MessageCircle className="h-4 w-4" />Contactar apoio
    </button>
  );
  return (
    <a href={`https://wa.me/${number}?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer"
      className={`${cls} bg-[#25D366] text-white hover:brightness-95`} data-testid="whatsapp-support-btn">
      <MessageCircle className="h-4 w-4" />Contactar apoio
    </a>
  );
}
